/* eslint-disable react/function-component-definition */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable prefer-destructuring */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'antd';
import { Loader } from 'lucide-react';
import CountUp from 'react-countup'; // Import CountUp for animation
import './index.css'; // Add your custom CSS styles
// import { useSpring, animated } from '@react-spring/web'; // Import react-spring
import { DataService } from '../../../config/dataService/dataService';

const CounterCard = ({
  apiUrl,
  title,
  icon: Icon,
  iconColor = '#1890ff',
  textColor = '#333',
  textSize = '1.5rem',
  labelSize = '0.875rem',
  backgroundColor = '#f5f5f5',
  animation = true,
}) => {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await DataService.post(apiUrl)
        if (response.data.status) {
          const data = response.data.data;
          setCount(data || 0); // Assume the API returns a `count` field}
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, [apiUrl]);

  return (
    <Card
      style={{
        borderRadius: '10px',
        // backgroundColor,
        overflow: 'hidden',
      }}
      className={animation ? 'counter-card animate-card' : 'counter-card'}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        {/* Icon Section */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '4rem',
            marginRight: '12px',
            color: iconColor, // Apply icon color here
          }}
        >
          {loading ? (
            <Loader color={iconColor} size={40} className='animate-spin' /> // Lucide Loader icon
          ) : (
            <Icon color={iconColor} size={40} /> // Lucide icon passed as prop
          )}
        </div>

        {/* Text Section */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            flex: 1,
          }}
        >
          <h2
            style={{
              fontSize: textSize,
              color: textColor,
              fontWeight: 'bold',
            }}
          >
            {loading ? '...' : <CountUp end={count} duration={1} />} {/* Use CountUp for animation */}
          </h2>
          <p
            style={{
              fontSize: '12px',
              color: textColor,
              opacity: 0.8,
              margin: 0,
            }}
          >
            {title}
          </p>
        </div>
      </div>
    </Card>
  );
};

CounterCard.propTypes = {
  apiUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  iconColor: PropTypes.string,
  textColor: PropTypes.string,
  textSize: PropTypes.string,
  labelSize: PropTypes.string,
  backgroundColor: PropTypes.string,
  animation: PropTypes.bool,
};

export default React.memo(CounterCard);
